import * as React from 'react';
const SvgInformation = (props) => (
  <svg viewBox="0 0 124 112" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.871 13.571A3.863 3.863 0 0 0 2 17.428v82.929a3.863 3.863 0 0 0 3.871 3.857h44.516c1.07 0 1.936.863 1.936 1.929a3.863 3.863 0 0 0 3.87 3.857h11.613a3.863 3.863 0 0 0 3.871-3.857c0-1.066.866-1.929 1.936-1.929h44.516a3.863 3.863 0 0 0 3.871-3.857V17.428a3.863 3.863 0 0 0-3.871-3.857"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.613 90.714S56.193 88.786 62 98.43V12.867C58.13 3.93 13.613 2 13.613 2v88.714ZM110.387 90.714S67.807 88.786 62 98.43V12.867C65.871 3.93 110.387 2 110.387 2v88.714Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M79.419 38.643h7.742V67.57M79.419 67.571h15.484"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.225 29a1.932 1.932 0 0 0 1.936-1.928 1.932 1.932 0 0 0-1.936-1.93 1.932 1.932 0 0 0-1.935 1.93c0 1.065.867 1.928 1.935 1.928Z"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
  </svg>
);
export default SvgInformation;
